/* JS - (c) 2019 mpunkt GmbH */
import $ from 'jquery';
import PerfectScrollbar from '../vendor/scrollbar';

// Helper
import './helper';

/**
 * Berechnet die Breite der Kontaktkarte im Desktopbereich und ordnet sie an
 */
window.calcContactMapWidth = function () {

    var contactMapWrap = $('.contact-partners-map');

    if (contactMapWrap.length === 0) {
        return;
    }

    if ($(window).width() > 1340) {
        contactMapWrap.removeAttr('style');

        var contactFiltersWrap = $('.contact-partners-filters');
        var contactMapWidth = $(window).width() - (contactFiltersWrap.offset().left + contactFiltersWrap.outerWidth());
        var contactMapPosition = $(window).width() - contactMapWrap.offset().left - contactMapWrap.outerWidth();

        contactMapWrap.css({
            'width': contactMapWidth + 'px',
            'right': '-' + contactMapPosition + 'px'
        });

        return;
    }

    contactMapWrap.css({
        'width': 'initial',
        'right': 'initial'
    });
};

/**
 * Toggle-Funktion für die Notfallnummer auf Ansprechpartner-Seiten (mit Karte)
 */
window.toggleMapEmergencyNumbers = function () {
    // Kontaktpartner (Karte): Notfallnummer toggle
    var emergencyHotlineWrap = $('.emergency-hotline');
    if (emergencyHotlineWrap.length > 0) {
        var emergencyHotlineList = emergencyHotlineWrap.find('ul');

        emergencyHotlineList.children('li').on('click', function () {
            $(this).closest('ul').addClass('has-active');
            $(this).addClass('active').siblings('li').removeClass('active');
        });

        emergencyHotlineWrap.children('header').on('click', emergencyHotlineList, function () {
            if (emergencyHotlineWrap.hasClass('active') && emergencyHotlineList.find('li.active').length > 0) {
                emergencyHotlineWrap.addClass('active');
                emergencyHotlineList.removeClass('has-active').children('li').removeClass('active');
            } else {
                $(this).parent(emergencyHotlineWrap).toggleClass('active');
            }
        });
    }
};

/**
 * Zur Kontaktliste springen (smooth scroll)
 */
window.scrollToResults = function (ele) {
    const partnersContent = $('.contact-partners-content');

    $('html, body').animate({
        scrollTop: partnersContent.offset().top
    }, 350);

    // Ansprechpartner markieren (short highlight)
    const partners = $(ele).data('partners');
    if (!!partners && partners.length > 0) {
        $.each(partners, function (key, value) {
            const partnerTile = $('.contact-partners-content').find('.csc-apartner[data-partner="' + value + '"]');

            partnerTile.each(function () {
                // Highlight-Klasse hinzufügen und wieder entfernen
                $(this).addClass('highlight');
            });

            setTimeout(function () {
                partnerTile.removeClass('highlight');
            }, 2000);
        });
    }
    return false;
};

/**
 * Kontaktkarte (Landingpage)
 * Akkordions
 */
window.companyLocationsAccordions = function () {
    var companyLocation = $('.company-location');

    if (companyLocation.length > 0) {
        companyLocation.each(function () {
            $(this).children('.company-location-header').on('click', function () {
                var companyLocationEle = $(this).closest('.company-location');

                // Toggle Akkordion
                companyLocationEle.toggleClass('active').children('.company-location-content').stop().slideToggle('fast');

                // Schließe alle anderen Akkordions
                companyLocationEle.siblings().removeClass('active').children('.company-location-content').stop().slideUp('fast');
            });
        });
        return true;
    }

    return false;
};

/**
 * Sidebar Filter Scrollbar
 */
window.mapSidebarScrollbar = function () {
    if ($('.contact-partners-filters-inner').length > 0) {
        if ($(window).width() >= 1340) {
            var perfectScrollbar = new PerfectScrollbar('.contact-partners-filters-inner', {
                wheelSpeed: 250
            });
        } else {
            perfectScrollbar = null;
        }
    }
};

/**
 * Kreis auf Karte zeichnen
 *
 * @param point
 * @param radius
 * @param dir
 * @returns {any[]}
 */
window.drawCircle = function (point, radius, dir) {
    var d2r = Math.PI / 180; // degrees to radians
    var r2d = 180 / Math.PI; // radians to degrees
    var earthsradius = 6371; // Erdradius in km

    var points = 32;

    // find the raidus in lat/lon
    var rlat = (radius / earthsradius) * r2d;
    var rlng = rlat / Math.cos(point.lat() * d2r);

    var extp = new Array();
    if (dir == 1) {
        var start = 0;
        var end = points + 1;
    } // one extra here makes sure we connect the
    else {
        var start = points + 1;
        var end = 0;
    }
    for (var i = start;
         (dir == 1 ? i < end : i > end); i = i + dir) {
        var theta = Math.PI * (i / (points / 2));
        var ey = point.lng() + (rlng * Math.cos(theta)); // center a + radius x * cos(theta)
        var ex = point.lat() + (rlat * Math.sin(theta)); // center b + radius y * sin(theta)
        extp.push(new google.maps.LatLng(ex, ey));
    }
    return extp;
};

/* ############################################ */

/**
 * Map-Logik
 */
function mapsCallback () {

    let autocomplete;

    // Google-Maps Autocomplete Init
    var autocompleteInput = 'map_location';

    // Nur nötige Informationen laden um Kosten (API) zu sparen
    var autocompleteFields = ['address_components', 'geometry'];

    // Standardausgangspunkt (Deutschland)
    var entryMarkerStandard = new google.maps.LatLng(48.0016638, 10.170373499999982);

    // Addressdaten erhalten
    // @TODO evtl. (wie bei Autocomplete möglich) nur die Felder "address_components" und "geometry" laden (Kostengründe!)
    var geocoder = new google.maps.Geocoder;

    // Formulardaten
    var formData = {
        competences: [],
        location: {},
        name: '',
        responsibility: '',
        lang: $('html').attr('lang'),
        page: typeof currentContactPage !== 'undefined' ? currentContactPage : 1,
        coordinate_corners: {}
    };

    let mapDisplayCount = 0;

    /**
     * Zeigt die Karte anhand vorgegebener Marker-Informationen (JSON) an
     *
     * @param markerData
     */
    $.fn.contactMapDisplay = function (markerData) {

        // Marker-Daten als JSON
        var markersJson = typeof markerData.markers !== 'undefined' ? markerData.markers : [];

        // Ergebnisanzahl auf Button setzen
        $('#contact-partners-toggle').attr('data-amount', markerData.results);

        // Mapstyle definieren
        var customMapType = new google.maps.StyledMapType(mapStyle, {
            name: 'Goldhofer Mapstyle'
        });
        var customMapTypeId = 'goldhofer_gm_style';

        // map options
        var options = {
            zoom: 12,
            mapTypeId: google.maps.MapTypeId.TERRAIN,
            mapTypeControl: false,
            disableDefaultUI: true,
            zoomControl: false,
            draggable: false,
            draggableCursor: 'default',
            scrollwheel: false,
            gestureHandling: 'greedy'
        };

        // Bei nur einem Marker, denselbigen als Kartenmittelpunkt bestimmen
        if (markersJson.length === 1) {
            for (var i = 0, length = 1; i < length; i++) {
                options.center = new google.maps.LatLng(markersJson[0].lat, markersJson[0].lng);
            }
        }

        // Map init
        var map = new google.maps.Map(document.getElementById('contact-map'), options);

        // Mehrere Marker setzen
        var fitMarkers = [];
        for (var i = 0, length = markersJson.length; i < length; i++) {

            var data = markersJson[i];

            // firstly convert coordinates to string and then replace dots to comma
            const markerLat = !(typeof data.lat === 'string') ? data.lat : data.lat.toString().replace(',', '.').replace(' ', '');
            const markerLng = !(typeof data.lng === 'string') ? data.lng : data.lng.toString().replace(',', '.').replace(' ', '');

            // init markers
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng({
                    lat: parseFloat(markerLat),
                    lng: parseFloat(markerLng),
                }),
                map: map,
                title: data.title,
                icon: {
                    url: MP_PATH + 'assets/img/icons/icon-map-marker-dest.svg',
                    scaledSize: new google.maps.Size(36, 36),
                }
            });

            // Infowindows
            (function (marker, i) {
                var markerInfo = [];

                // Click-Event
                markerInfo[i] = google.maps.event.addListener(marker, 'click', function () {
                    if (typeof markersJson[i].html !== 'undefined') {
                        // Infowindow nur einmal definieren
                        if (typeof markerInfo[i].content === 'undefined') {
                            markerInfo[i] = new google.maps.InfoWindow({
                                content: $.parseHTML(markersJson[i].html)[0].data
                            });
                        }

                        // Notfallhotline verstecken, wenn geklickt (mobile only)
                        if ($(window).width() < 1340) {
                            $('.emergency-hotline').hide();
                        }

                        markerInfo[i].open(map, marker);
                    }
                });
            })(marker, i);

            // Marker in Array, um diese später innerhalb der Karte zentriert ausrichten zu können
            fitMarkers.push(marker.position);
        }

        // Suchziel/Ausgangspunkt auf Karte markieren
        if (!formData.noEntryMarker) {
            var entryMarker = new google.maps.Marker({
                position: entryMarkerStandard,
                map: map,
                icon: {
                    url: MP_PATH + 'assets/img/icons/icon-map-marker-start.svg',
                    scaledSize: new google.maps.Size(33, 33),
                },
                visible: false
            });
        }

        if (typeof markerData.entry !== 'undefined') {
            if (!!entryMarker) {
                entryMarker.setPosition(new google.maps.LatLng(markerData.entry.lat, markerData.entry.lng));

                // Einstiegsmarker in Marker-Array für Berücksichtigung bei Endpositionierung (bounds)
                fitMarkers.push(entryMarker.position);
            }

            // Karte nun freischalten für: Drag-Funktion, Zoom-Funktion
            map.setOptions({ draggableCursor: '', draggable: true, zoomControl: true });

            // Backup Umkreissuche (Deaktivierung Umkreissuche https://pm/eintraege/auftraege/5245)
            // Radienmarkierung bei Umkreissuche
            // if (!!markerData.entry.radii) {
            //     const resultRadii = JSON.parse(markerData.entry.radii);
            //     const radiColors = { 25: '#38ab21', 50: '#fee34d', 100: '#ec8736' };
            //
            //     // Radien iterieren
            //     for (let i = 0, len = resultRadii.length; i < len; i++) {
            //         if (i === 0) {
            //             // Ersten Radius mit Circle-Klasse von Google Maps realisieren
            //             new google.maps.Circle({
            //                 map: map,
            //                 radius: resultRadii[i] * 1000, // meter in km (Umberechnung)
            //                 fillColor: radiColors[resultRadii[i]],
            //                 fillOpacity: 0.3,
            //                 strokeOpacity: 0,
            //                 center: { lat: markerData.entry.lat, lng: markerData.entry.lng }
            //             });
            //         } else {
            //             // Weitere Radien als Polygon realisieren, um Aussparungen für die jeweiligen bereits vorhanden Radien zu lassen
            //             const circlePosition = new google.maps.LatLng(markerData.entry.lat, markerData.entry.lng);
            //             new google.maps.Polygon({
            //                 paths: [
            //                     drawCircle(circlePosition, resultRadii[i], 1),
            //                     drawCircle(circlePosition, resultRadii[i - 1], -1)
            //                 ],
            //                 fillColor: radiColors[resultRadii[i]],
            //                 fillOpacity: 0.3,
            //                 strokeOpacity: 0,
            //                 map: map
            //             });
            //         }
            //     }
            // }
        }

        // Bei Verschieben der Karte neuen Kartenmittelpunkt suchen und anhand dess neue Suche starten
        /*google.maps.event.addListener(map, 'dragend', function () {
            var newMapCenter = this.getCenter();

            geocoder.geocode({
                location: new google.maps.LatLng(newMapCenter.lat(), newMapCenter.lng()),
            }, function (results, status) {
                if (status === 'OK') {
                    formData.location = results[0];

                    // Formatierte, geänderte Adresse innerhalb des Autocompletes-Inputs ändern
                    $('#' + autocompleteInput).val(results[0]['formatted_address']);

                    // Ausgangsmarker initial setzen
                    // Kommt nur vor, wenn Karte ohne Eingaben im Formular via Drag bedient wird
                    if (formData.noEntryMarker) {
                        formData.noEntryMarker = undefined;
                    }

                    // Query ausführen
                    // Karte ausführen
                    $.triggerForm(formData);
                }
            });
        });*/

        //  Marker die an den Rand angrenzen automatisch zentrieren
        if (fitMarkers.length !== 1) {
            var bounds = new google.maps.LatLngBounds();
            for (var i = 0; i < fitMarkers.length; i++) {
                bounds.extend(fitMarkers[i]);
            }

            // Marker positionieren und an die Karte anpassen
            // Ausgangs-Marker (unsichtbar) in der Mitte zentrieren
            map.fitBounds(bounds, { top: 160, right: 60, bottom: 60, left: 60 });
            google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
                if (!!entryMarker) {
                    map.setCenter(entryMarker.getPosition());
                }

                map.setZoom(map.getZoom() - 1);
            });
        }

        // Map-Styles setzen
        map.mapTypes.set(customMapTypeId, customMapType);
        map.setMapTypeId(customMapTypeId);

        mapDisplayCount++;
    };

    /**
     * Zeigt die Ansprechpartner anhand vorgegebener Marker-Informationen (JSON) an
     *
     * @param partnersData
     */
    $.fn.partnersDisplay = function (partnersData) {
        $.ajax({
            url: MP_PATH + 'ajax/ajax.list_gm_contact_partners.php',
            data: { data: JSON.stringify(partnersData) },
            type: 'POST',
            success: function (html) {
                $('#fcp_partners_content').html(html);
            }
        });
    };

    /**
     * Führt einen Suchbefehl durch
     *
     * @param postData
     * @param callback
     */
    $.fn.contactMapQueryPartners = function (postData, callback) {
        if (typeof postData === 'undefined') {
            postData = {};
        }

        // Ajax-Request
        $.ajax({
            url: MP_PATH + 'api/api.query_gm.php',
            data: { query: JSON.stringify(postData) },
            type: 'POST',
            dataType: 'json',
            success: callback
        });
    };

    /**
     * Führt einen Suchbefehl durch
     * Zeigt die Karte an
     * Zeigt die Ansprechpartner an
     *
     * @param params
     */
    $.fn.contactMapQuery = function (params) {
        if (typeof params === 'undefined') {
            params = {};
        }

        $.fn.contactMapQueryPartners(params, function (data) {
            $.fn.contactMapDisplay(data);
            $.fn.partnersDisplay(data);
        });
    };

    /**
     * Formular inkl. Autocomplete ausführen
     * @param formData
     * @param autocompleteInput
     * @param initial
     */
    $.triggerForm = function (formData, autocompleteInput, initial = false) {
        if (!$.isEmptyObject(formData.location)) {
            $('#' + autocompleteInput).parent('.form-field').removeClass('error');

            // Google-Maps Autocomplete: Ortsdaten
            // Query ausführen
            $.fn.contactMapQueryPartners(formData, function (data) {
                // Karte anzeigen
                $.fn.contactMapDisplay(data);
                // Ansprechpartner anzeigen
                $.fn.partnersDisplay(data);
            });
        } else {
            // Karte beim ersten Laden der Seite ohne Marker anzeigen
            if (initial) {
                $.fn.contactMapDisplay({});
                return;
            }

            // Kein Ort angegeben
            // Autocomplete-Field markieren
            $('#' + autocompleteInput).parent('.form-field').addClass('error');
        }
    };

    /**
     * Bereitet ein Objekt mit allen vom Nutzer angegebenen Filtern vor
     */
    $.fn.contactMapPrepareFilterInformation = function (resetAutocomplete, initial = false) {
        if (typeof resetAutocomplete === 'undefined') {
            resetAutocomplete = false;
        }

        let noReset = false;
        const formSelector = $('#filter_contact_partners');

        // Responsibility
        formData.responsibility = formSelector.find('select#fcp_map_responsibility').val();

        // Name
        formData.name = formSelector.find('input[type=text]#fcp_map_name').val();

        // Checkboxen: Kontaktwünsche ("competences")
        formData.competences = formSelector.find('input[type=checkbox]:checked').map(function () {
            return $(this).val();
        }).toArray();

        // Geänderte Ortsdaten übernehmen, wenn Input geändert
        formData.noEntryMarker = false;

        // Überprüfen, ob in Ortsauswahl etwas eingetragen ist
        var emptyAddressInput = document.getElementById(autocompleteInput).value.length === 0

        // Bei Ortswahl in Autocomplete, Formular ausführen
        if (typeof autocomplete !== 'undefined' && typeof autocomplete.getPlace() !== 'undefined' && !emptyAddressInput) {
            // first, check which type of location the queried place is
            const selectedPlace = autocomplete.getPlace();

            // determinate center of queried place and apply result for later
            geocoder.geocode({ location: selectedPlace.geometry.location }, function (results, status) {
                if (status === 'OK') {
                    formData.location = results[0];

                    // Check if in one of the results is of type country/postal_code and put in formData.location
                    if (results.length > 1) {
                        for (let i = 1, length = results.length; i < length; i++) {
                            let result = results[i];

                            if(Array.isArray(result.types) && (result.types.includes('country') || result.types.includes('postal_code'))) {
                                if(!Array.isArray(result.address_components) || result.address_components.length <= 0) {
                                    continue;
                                }

                                // First array element is always the same as result.types
                                let firstAddressComponent = result.address_components[0];

                                // Get country or postal code
                                ['country', 'postal_code'].forEach(function(addressComponentsType){
                                    if(firstAddressComponent.types.includes(addressComponentsType)) {

                                        // Check if country is already in formData.location.address_components
                                        let addressComponentTypeIsAlreadyInFormData = false;
                                        formData.location.address_components.forEach(function(addressComponent) {
                                            if(addressComponent.types.includes(addressComponentsType)) {
                                                addressComponentTypeIsAlreadyInFormData = true;
                                            }
                                        });

                                        if(!addressComponentTypeIsAlreadyInFormData) {
                                            formData.location.address_components.push(firstAddressComponent);
                                        }
                                    }
                                });
                            }
                        }
                    }

                    $.triggerForm(formData, autocompleteInput);
                    return false;
                }
            });

            // if center query was successfull stop search at this point
            if (formData.location !== '') {
                return;
            }

            formData.location = selectedPlace;
            $.triggerForm(formData, autocompleteInput);
            return;
        }

        // Check if input field for location is empty
        if (emptyAddressInput) {
            formData.location = {};
            $.triggerForm(formData, autocompleteInput, initial);
            return;
        }

        if (!resetAutocomplete) {
            formData.location = undefined;
            formData.noEntryMarker = true;

            geocoder.geocode({ location: entryMarkerStandard, }, function (results, status) {
                if (status === 'OK') {
                    formData.location = results[0];
                }
            });

            const interval = setInterval(function () {
                if (!formData.location) {
                    return;
                }

                clearInterval(interval);
                $.triggerForm(formData, autocompleteInput);
            }, 50);

            return;
        }

        // Wenn kein expliziter Ort in der Auswahlliste gewählt, Ort zurücksetzen
        if (!noReset) {
            formData.location = {};
            $.triggerForm(formData, autocompleteInput);
        }
    };

    /**
     * Führt die Filterung der Kontaktdaten aus
     * - überwacht Änderungen im Formular
     * - überwacht Änderungen/Aktionen innerhalb der Karte
     */
    $(function () {

        $(document).ready(function () {

            // Autocomplete Text-Input
            const autocompleteInputField = document.getElementById(autocompleteInput);

            // store the original event binding function
            const _addEventListener = (autocompleteInputField.addEventListener) ? autocompleteInputField.addEventListener : autocompleteInputField.attachEvent;

            /**
             * Automatische Auswahl des ersten Suchergebnisses in der Auswahlliste durch Bestätigen von "Enter"
             *
             * @param type
             * @param listener
             */
            function addEventListenerWrapper (type, listener) {
                // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
                // and then trigger the original listener.
                if (type === 'keydown') {
                    const orig_listener = listener;
                    listener = function (event) {
                        const suggestion_selected = $('.pac-item-selected').length > 0;
                        if (event.which === 13 && !suggestion_selected) {
                            const simulated_downarrow = $.Event('keydown', {
                                keyCode: 40,
                                which: 40
                            });
                            orig_listener.apply(autocompleteInputField, [simulated_downarrow]);
                        }

                        orig_listener.apply(autocompleteInputField, [event]);
                    };
                }

                _addEventListener.apply(autocompleteInputField, [type, listener]);
            }

            autocompleteInputField.addEventListener = addEventListenerWrapper;
            autocompleteInputField.attachEvent = addEventListenerWrapper;

            // Autocomplete init
            autocomplete = new google.maps.places.Autocomplete(autocompleteInputField);

            // Nur Informationen "address_components", um Kosten (API) zu sparen
            autocomplete.setFields(autocompleteFields);

            // Bei Autocomplete Suche starten
            $.fn.contactMapPrepareFilterInformation(false, true);
            autocomplete.addListener('place_changed', function () {
                $.fn.contactMapPrepareFilterInformation();
            });
        });

        // Bei Formularänderung Suche starten
        $('.filter-contact-partners-input').on('change', function () {
            $.fn.contactMapPrepareFilterInformation();
        });

        // Custom-Scrollbar für Map-Sidebar
        mapSidebarScrollbar();
        $(window).on('resize', mapSidebarScrollbar);

        // Kontakte anzeigen wenn Klick auf Button unter Filteroptionen
        $('#contact-partners-toggle').on('click', scrollToResults);
    });
}

// Google Maps API initialisieren
if (!('google' in window) && typeof gmApiKey !== 'undefined') {
    $.loadScript('https://maps.googleapis.com/maps/api/js?libraries=places,geometry&language=' + $('html').attr('lang') + '&key=' + gmApiKey, mapsCallback);
}

// check DOM Ready
$(document).ready(function () {

    // Notfallnummern toggeln
    toggleMapEmergencyNumbers();

    // Landingpage (Akkordion toggle)
    if (companyLocationsAccordions()) {
        // Custom-Scrollbar für Map-Sidebar
        mapSidebarScrollbar();
        $(window).on('resize', mapSidebarScrollbar);
    }

    // Berechnung der Map-Breite
    calcContactMapWidth();
    $(window).on('resize', calcContactMapWidth);

});